module.exports = __webpack_public_path__ + "static/organicorangespot-e2910d6eb359ce07bda8a42f2cc25b9f.jpeg";